import { api } from '@wix/promote-analytics-adapter';
import { trackEvent } from './track-event';
import type { WixAnalytics, ReportProps } from './types';

export const init = () => {
  api.init([
    {
      name: 'biAnalytics',
      report({ src, evid, ...params }: ReportProps) {
        window.wixBi.report({
          src,
          evid,
          params: {
            ...params,
            url: document.location.href,
            ref: document.referrer,
            bl: window.navigator.language,
            pl: window.navigator.languages
              ? window.navigator.languages.slice(0, 5).join(',')
              : '',
          },
        });
      },
    },
  ]);

  const wixAnalytics: WixAnalytics = {
    trackEvent,
  };

  Object.defineProperty(window, 'wixAnalytics', {
    value: Object.freeze(wixAnalytics),
    writable: false,
    configurable: false,
    enumerable: true,
  });
};
